import { MenuContent, MenuRoot, MenuTrigger, ButtonIcon } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import {
  GoalFocusAreaMenuEditButton,
  GoalFocusAreaDeleteButton,
} from 'features/goal';

type TGoalFocusAreaMenu = {
  focusAreaId: string;
  title: string;
};

export const GoalFocusAreaMenu = ({
  focusAreaId,
  title,
}: TGoalFocusAreaMenu) => {
  return (
    <MenuRoot>
      <MenuTrigger asChild>
        <ButtonIcon aria-label="add focus area menu" variant="ghost" size="2xs">
          <Icon name={iconNames.ellipsisHorizontal} />
        </ButtonIcon>
      </MenuTrigger>
      <MenuContent py="1px" overflow="hidden">
        <GoalFocusAreaMenuEditButton focusAreaId={focusAreaId} title={title} />
        <GoalFocusAreaDeleteButton focusAreaId={focusAreaId} />
      </MenuContent>
    </MenuRoot>
  );
};
